<script lang="ts" setup>
import { useUrlSearchParams } from '@vueuse/core'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import LogoSvg from '@/assets/svg/logo.svg'
import { states } from '@/store'

import AppButtonIcon from '../atoms/AppButtonIcon.vue'
import AppButtonText from '../atoms/AppButtonText.vue'
import LocaleSwitcher from '../molecules/LocaleSwitcher.vue'

const { app } = useUrlSearchParams('hash')
const route = useRoute()

const isAudioguidePage = computed(() => (route.name as string).includes('Audioguide'))

const toggleMenu = () => { states.menu.visible = !states.menu.visible }
const toggleWorkingHours = () => { states.workingHours.visible = !states.workingHours.visible }
</script>

<template>
  <header
    :class="[
      { 'lt-lg:pt-8': app === 'true' },
      states.menu.visible ? 'bg-transparent' : states.header.backgroundColor,
      states.menu.visible ? 'c-black' : states.header.color
    ]"
    class="fixed left-0 top-0 right-0 z-100 p-4 lg:p-8 pointer-events-none"
  >
    <nav class="relative grid grid-cols-12 gap-4 lg:gap-8">
      <ul class="col-span-4 flex items-center justify-start gap-4 lg:gap-8">
        <li v-if="!isAudioguidePage" class="flex pointer-events-auto">
          <AppButtonText
            :active="states.menu.visible"
            :aria-label="$t('accessibility.cta.menu')"
            :title="$t('accessibility.cta.menu')"
            @click="toggleMenu"
          >
            {{ $t('global.header.menu') }}
          </AppButtonText>
        </li>
        <li v-if="!isAudioguidePage" class="flex pointer-events-auto">
          <AppButtonIcon
            :active="states.workingHours.visible"
            :aria-label="$t('accessibility.cta.workingHours')"
            :title="$t('accessibility.cta.workingHours')"
            icon="wh"
            size="sm"
            @click="toggleWorkingHours"
          />
        </li>
        <li v-if="isAudioguidePage" class="flex pointer-events-auto">
          <LocaleSwitcher />
        </li>
      </ul>
      <ul class="col-span-4 flex items-center justify-center gap-4 lg:gap-8">
        <li class="flex pointer-events-auto">
          <component
            :is="isAudioguidePage ? 'div' : 'router-link'"
            v-track="!isAudioguidePage && { eventCategory: 'Header', eventAction: 'Click', eventLabel: 'Logo' }"
            :to="isAudioguidePage ? null : { name: 'Home' }"
            :title="isAudioguidePage ? null : $t('accessibility.homeLink')"
          >
            <LogoSvg class="min-h-6 w-30 lg:w-70 !opacity-0" />
          </component>
        </li>
      </ul>
      <ul class="col-span-4 flex items-center justify-end gap-4 lg:gap-8">
        <li class="flex pointer-events-auto">
          <div id="header-top-right" />
        </li>
        <li v-if="!isAudioguidePage" class="flex pointer-events-auto">
          <LocaleSwitcher />
        </li>
      </ul>
    </nav>
  </header>
</template>

<style lang="scss" scoped>
header {
  transition: background-color $default-duration ease;

  a,
  button {
    transition: color $default-duration ease !important;
  }
}
</style>
